import React from 'react';
import { Link } from 'react-router-dom';
import FLogo from '../images/common/f_logo.png';
import FLogo2x from '../images/common/f_logo@2x.png';

const Footer = () => {
  return (
    <footer>
      <div className="f_blc">
        <h2 className="f_logo">
          <Link to="/">
            <img
              src={ FLogo }
              srcSet={ `${ FLogo } 1x, ${ FLogo2x } 2x` }
              alt="Ton Bébé"
            />
          </Link>
        </h2>
        <ul className="f_nav">
          <li><Link to="/terms">利用規約</Link></li>
          <li><Link to="/privacy">プライバシーポリシー</Link></li>
          <li><Link to="/cookie_policy">クッキーポリシー</Link></li>
          <li><Link to="/commerce">特定商取引法に基づく表記</Link></li>
          <li><a href="https://note.com/tonbebe">ブログ</a></li>
          <li><Link to="/faq">ヘルプ</Link></li>
        </ul>
        <small>©2019-{ new Date().getFullYear() } Ton Bébé</small>
      </div>
    </footer>
  );
}

export default Footer;
